/* eslint-disable react/jsx-no-useless-fragment */
import { Button } from "@fc/devteam-components-library";
import { CSSProperties, useState } from "react";
import ModalComponet, { ModalFooter, ModalTitle } from ".";

interface InfoModalProps {
    title: string
    info: React.ReactNode
    infoElement? : boolean
    bibliography?: string[]
    linkMore?: string
    iconPrefix?: 'fad' | 'fas'
    style?: CSSProperties
}

export default function InfoModal(props: InfoModalProps) {
    const { info, title, bibliography, linkMore, iconPrefix, style,infoElement } = props
    const [openInfo, setOpenInfo] = useState<boolean>(false)

    const redirect = () => {
        window.open(`${linkMore}`,"menubar = 0, scrollbars = 0");
    }
    return (
        <>
        <em className={`${iconPrefix ? iconPrefix : 'fas'} fa-info-circle`} onClick={() => setOpenInfo(!openInfo)}/>
        <ModalComponet open={openInfo} onClose={() => setOpenInfo(false)} hiddenScroll>
            <>
                <ModalTitle label={title} onClose={() => setOpenInfo(false)} />
                {infoElement ? 
                    info
                    :
                    <div className="Services__FlexContent">
                        <p className="Card__InsideValueType">
                            {info}
                        </p>
                    </div>
                }
                {bibliography?.length ?
                <>
                    <div className="Services__FlexContent">
                        <strong><p>Enlace</p></strong>
                    </div>
                    {bibliography.map((link) =>
                        <div className="Services__FlexContent">
                                <a className="Bullets__Active" href={link} target='_blank' rel="noreferrer">
                                    { link }
                                </a>
                        </div>
                    )}
                </>
                : null}
                <ModalFooter>
                    <>
                    {linkMore ? 
                        <Button
                            buttontype="button"
                            buttontext="Saber mas"
                            action={redirect}
                        />
                    : null}
                    </>
                </ModalFooter>
            </>
        </ModalComponet>
        </>
    )
}